import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "0813e5e0-d317-40c7-bea4-f676a98cf5d6",
  publicId: "26",
  name: "Dissipation",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [principle01, task01, task02, task03],
};

export default lesson;
